import router from "../../router";
import missionApi from "@/api/missionApi";
import Mission from "@/model/mission";

export default {
  state: {
    missionList: []
  },
  getters: {
    missionList(state) {
      return state.missionList;
    }
  },
  mutations: {
    setMissionList(state, missionList) {
      state.missionList = missionList;
    }
  },
  actions: {
    async refreshMissionList(context) {
      const getters = context.getters;
      if (!getters.selectedAdAccount) {
        return;
      }
      context.commit('setMissionList', []);
      if(!getters.selectedAdAccount.detail){
        await context.dispatch("getAdAccountDetail", getters.selectedAdAccount.id);
      }
      if (getters.selectedAdAccount) {
        const missions = (await missionApi.getMissionsByCampaignIds(getters.selectedAdAccount.campaigns.map(elm => elm.id)))?.data?.data?.missions || [];
        context.commit('setMissionList', missions.map(elm=>new Mission(elm)));
      }
    }
  }
}
